/** Armazón común: cabecera con el usuario en sesión y salida del router. */

import { Network } from 'lucide-react'
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom'

import { useSesion } from './api/sesion'
import logoCircularTec from './assets/circulartec.png'
import { MenuUsuario } from './componentes/MenuUsuario'
import { Cargando } from './ui/primitivos'

/**
 * Deja pasar solo con sesión iniciada.
 *
 * Mientras se comprueba no se decide nada: pintar el login durante ese
 * instante hace parpadear la pantalla en cada recarga, aunque haya sesión.
 * La ruta de origen viaja en el estado para volver a ella tras entrar.
 */
export function Armazon() {
  const { data: usuario, isLoading } = useSesion()
  const ubicacion = useLocation()

  if (isLoading) {
    return (
      <div className="grid min-h-screen place-items-center">
        <Cargando texto="Comprobando la sesión…" />
      </div>
    )
  }

  if (!usuario) {
    return <Navigate to="/login" replace state={{ desde: ubicacion.pathname }} />
  }

  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-20 flex h-12 shrink-0 items-center justify-between gap-4 border-b border-[var(--color-borde)] bg-[var(--color-panel)] px-4">
        <div className="flex min-w-0 items-center gap-3">
          <Link
            to="/"
            className="inline-flex shrink-0 items-center gap-2 text-[14px] font-semibold tracking-tight"
          >
            <Network size={17} className="text-[var(--color-acento)]" />
            StakeMap
          </Link>

          <span aria-hidden className="h-5 w-px shrink-0 bg-[var(--color-borde)]" />

          {/* El azul del logo (#1d70b7) contrasta 5.2:1 sobre el panel claro
              pero solo 2.6:1 sobre el oscuro, donde se apaga. El filtro lo
              levanta solo en ese tema, sin tocar el archivo. */}
          <img
            src={logoCircularTec}
            alt="CircularTec"
            width={250}
            height={67}
            className="h-[19px] w-auto shrink-0 dark:brightness-[1.5] dark:saturate-[1.15]"
          />
        </div>

        <MenuUsuario usuario={usuario} />
      </header>

      <main className="min-h-0 flex-1">
        <Outlet />
      </main>
    </div>
  )
}
